import { jsx as v } from "react/jsx-runtime";
import { c as L } from "../../index-2QXL0WYc.js";
import { RadioGroupLayout as S } from "./RadioGroup.types.js";
import { forwardRef as W, useRef as j, useMemo as w, useImperativeHandle as D } from "react";
import { useControlledState as F } from "../../hooks/useControlledState.js";
import { RadioGroupContext as H } from "./RadioGroupContext.js";
import { useNoDefaultValueInForms as M } from "../Form/hooks/useNoDefaultValueInForms.js";
const P = "ids-radio-group-v5150", z = "ids-radio-group--stack-v5150", A = "ids-radio-group--block-v5150", B = "ids-radio-group--inline-v5150", J = "ids-radio-group--inline-flex-v5150", K = "ids-radio-group--inline-equal-width-v5150", G = {
  radioGroup: P,
  stack: z,
  "ids-radio": "ids-radio-v5150",
  block: A,
  "ids-radio--label": "ids-radio--label-v5150",
  inline: B,
  inlineFlex: J,
  inlineEqualWidth: K
}, R = W(
  ({
    children: b,
    className: k,
    hiddenRadio: d,
    layout: l = "stack",
    name: u,
    onChange: r,
    onFocus: e,
    required: p,
    role: x = "radiogroup",
    defaultValue: c,
    readonly: n,
    value: I,
    touch: m,
    ...g
  }, N) => {
    M({
      component: "IressRadioGroup",
      defaultValue: c
    });
    const s = j(null), o = s.current, { value: f, setValue: a } = F({
      component: "IressRadioGroup",
      defaultValue: c,
      value: I
    }), q = w(
      () => ({
        name: u,
        value: f,
        hiddenRadio: d,
        required: p,
        readonly: n,
        touch: m,
        onChange: (t, i) => {
          a(i), r == null || r(t, i);
        }
      }),
      [u, f, d, p, n, a, r, m]
    );
    D(N, () => ({
      // React hook form requires the focus, blur, input
      focus: () => o == null ? void 0 : o.focus(),
      blur: () => o == null ? void 0 : o.blur(),
      input: o,
      reset: () => a(void 0)
    }));
    const y = (t) => {
      var i;
      e == null || e(t), t.target === s.current && ((i = s.current.querySelector("input")) == null || i.focus());
    };
    return /* @__PURE__ */ v(H.Provider, { value: q, children: /* @__PURE__ */ v(
      "div",
      {
        ...g,
        ref: s,
        role: x,
        className: L(k, G.radioGroup, {
          [G[l]]: !!l
        }),
        onFocus: y,
        children: b
      }
    ) });
  }
);
R.displayName = "IressRadioGroup";
R.Layout = S;
export {
  R as IressRadioGroup
};
